import * as actionTypes from "../actions";

import * as constants from "../../constants";


const initialState = {
    restaurantSettings: {
        id: null,
        name: constants.RESTAURANT_NAME_TEXT,
        address: constants.RESTAURANT_ADDRESS_TEXT,
        phone: "",
        email: "",
        website: "",
        latitude: 50.7459,
        longitude: 3.2193,
        zoom: 16,
        logo: null,
        banner: null,
        online: false,
        reservation_duration: "02:00:00",
        reservation_before_duration: "01:00:00",
        duration_before_service: true,
        show_cake: false,
        cake_before_duration: "1 00:00:00",
        show_stroller: false,
        show_highchair: false,
        show_reduced_mobility: false,
        show_terrace: false,
    },
    getRestaurantSettingsLoading: false,
    getRestaurantSettingsError: null,

    closedDays: [],
    getClosedDaysLoading: false,
    getClosedDaysError: null,

    openingHours: [],
    getOpeningHoursLoading: false,
    getOpeningHoursError: null,

    defaultShifts: [],
    getDefaultShiftsLoading: false,
    getDefaultShiftsError: null,

    shifts: {},
    shiftsMonths: new Set(),
    getShiftsLoading: false,
    getShiftsError: null,

    maxSeats: 0,
    getMaxSeatsLoading: false,
    getMaxSeatsError: null,

    checkAvailabilityLoading: false,
    checkAvailabilityError: null,
};

const settingsReducer = (state = initialState, action) => {
    switch (action.type) {

        // GET RESTAURANT SETTINGS
        case actionTypes.GET_RESTAURANT_SETTINGS_REQUEST:
            return {
                ...state,
                getRestaurantSettingsLoading: action.loading
            };
        case actionTypes.GET_RESTAURANT_SETTINGS_SUCCESS:
            return {
                ...state,
                getRestaurantSettingsLoading: action.loading,
                getRestaurantSettingsError: action.error,
                restaurantSettings: action.restaurantSettings
            };
        case actionTypes.GET_RESTAURANT_SETTINGS_ERROR:
            return {
                ...state,
                getRestaurantSettingsLoading: action.loading,
                getRestaurantSettingsError: action.error
            };

        // GET CLOSED DAYS
        case actionTypes.GET_CLOSED_DAYS_REQUEST:
            return {
                ...state,
                getClosedDaysLoading: action.loading
            };
        case actionTypes.GET_CLOSED_DAYS_SUCCESS:
            return {
                ...state,
                getClosedDaysLoading: action.loading,
                getClosedDaysError: action.error,
                closedDays: action.closedDays
            };
        case actionTypes.GET_CLOSED_DAYS_ERROR:
            return {
                ...state,
                getClosedDaysLoading: action.loading,
                getClosedDaysError: action.error
            };

        // GET OPENING HOURS
        case actionTypes.GET_OPENING_HOURS_REQUEST:
            return {
                ...state,
                getOpeningHoursLoading: action.loading
            };
        case actionTypes.GET_OPENING_HOURS_SUCCESS:
            return {
                ...state,
                getOpeningHoursLoading: action.loading,
                getOpeningHoursError: action.error,
                openingHours: action.openingHours
            };
        case actionTypes.GET_OPENING_HOURS_ERROR:
            return {
                ...state,
                getOpeningHoursLoading: action.loading,
                getOpeningHoursError: action.error
            };

        // GET DEFAULT SHIFTS
        case actionTypes.GET_DEFAULT_SHIFTS_REQUEST:
            return {
                ...state,
                getDefaultShiftsLoading: action.loading
            };
        case actionTypes.GET_DEFAULT_SHIFTS_SUCCESS:
            return {
                ...state,
                getDefaultShiftsLoading: action.loading,
                getDefaultShiftsError: action.error,
                defaultShifts: action.defaultShifts,
            };
        case actionTypes.GET_DEFAULT_SHIFTS_ERROR:
            return {
                ...state,
                getDefaultShiftsLoading: action.loading,
                getDefaultShiftsError: action.error
            };

        // RESET SHIFTS
        case actionTypes.RESET_SHIFTS:
            return {
                ...state,
                shifts: {},
                shiftsMonths: new Set(),
            };

        // GET SHIFTS
        case actionTypes.GET_SHIFTS_REQUEST:
            return {
                ...state,
                getShiftsLoading: action.loading
            };
        case actionTypes.GET_SHIFTS_SUCCESS:
            return {
                ...state,
                getShiftsLoading: action.loading,
                getShiftsError: action.error,
                shifts: action.shifts,
                shiftsMonths: action.month ? new Set([...state.shiftsMonths, action.month]): state.shiftsMonths,
            };
        case actionTypes.GET_SHIFTS_ERROR:
            return {
                ...state,
                getShiftsLoading: action.loading,
                getShiftsError: action.error
            };

        // GET MAX SEATS
        case actionTypes.GET_MAX_SEATS_REQUEST:
            return {
                ...state,
                getMaxSeatsLoading: action.loading
            };
        case actionTypes.GET_MAX_SEATS_SUCCESS:
            return {
                ...state,
                getMaxSeatsLoading: action.loading,
                getMaxSeatsError: action.error,
                maxSeats: action.maxSeats
            };
        case actionTypes.GET_MAX_SEATS_ERROR:
            return {
                ...state,
                getMaxSeatsLoading: action.loading,
                getMaxSeatsError: action.error
            };

        // CHECK AVAILABILITY
        case actionTypes.CHECK_AVAILABILITY_REQUEST:
            return {
                ...state,
                checkAvailabilityLoading: action.loading
            };
        case actionTypes.CHECK_AVAILABILITY_SUCCESS:
            return {
                ...state,
                checkAvailabilityLoading: action.loading,
                checkAvailabilityError: action.error,
            };
        case actionTypes.CHECK_AVAILABILITY_ERROR:
            return {
                ...state,
                checkAvailabilityLoading: action.loading,
                checkAvailabilityError: action.error
            };

        default:
            return state;
    }
};

export default settingsReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/settings.js